/*
 * Hero
 */
export const PROJECTS_HERO_TITLE = "See the work we've done";

export const PROJECTS_HERO_DESC = `View the design, build, and renovation projects we've completed throughout Claremore, OK and the surrounding areas. Imagine what we could accomplish working together.`;
